import { action } from 'satcheljs';

export default action('ON_AUTOMATIC_REPLY_GET_CALENDAR_EVENTS_TO_DECLINE');
